(function ($) {
    $.fn.dynamicchoice = function () {

        return this.each(function () {
            var myDynamicchoice = $(this);
            var cache = {};
            var src = myDynamicchoice.data('src');
            var parent = '#' + myDynamicchoice.data('parent');

            $(myDynamicchoice).bind('refresh', function (event) {

                var id = $(parent).val();
                if ($(cache[id]).find('input').length) {
                    $(myDynamicchoice).find('.tego-result').html(cache[id]);
                } else {
                    $(myDynamicchoice).find('.tego-result').html('Aucun résultat');
                }
                $(myDynamicchoice).change();

            });

            $(parent).bind('change', function (event) {

                var id = $(this).val();

                if (id in cache) {
                    $(myDynamicchoice).trigger('refresh');
                    return;
                }

                $.ajax({
                    type: 'POST',
                    url: src,
                    data: {'q': id},
                    beforeSend: function () {
                        $(myDynamicchoice).addClass('ui-autocomplete-loading');
                    },
                    complete: function () {
                        $(myDynamicchoice).removeClass('ui-autocomplete-loading');
                    },
                    success: function (data, status, xhr) {
                        cache[id] = data;
                        $(myDynamicchoice).trigger('refresh');
                    }
                });
            });

            if (!$(myDynamicchoice).find('input').length) {
                $(myDynamicchoice).find('.tego-result').html('Aucun résultat');
            }

            return myDynamicchoice;
        });
    };

}(jQuery));
